import { splitGrapheme } from "./splitGrapheme";

export const textLength = (str: string) => {
  return splitGrapheme(str).length;
};

export const textLengthFast = (str: string) => {
  return str.length;
}